var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal-card",
      style: { minHeight: 60 + "vh", minWidth: 60 + "vw" },
    },
    [
      _c("header", { staticClass: "modal-card-head" }, [
        _c("p", { staticClass: "modal-card-title" }, [
          _vm._v(" Email reminder history detail "),
        ]),
        _c("button", {
          staticClass: "delete",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$emit("on-close")
            },
          },
        }),
      ]),
      _c(
        "section",
        { staticClass: "modal-card-body" },
        [
          _c("p", { staticClass: "mb-3" }, [
            _vm._v(
              " " +
                _vm._s(_vm.distributor.id) +
                " - " +
                _vm._s(_vm.distributor.name) +
                " "
            ),
          ]),
          _c("b-loading", {
            attrs: { "is-full-page": false },
            model: {
              value: _vm.isLoading,
              callback: function ($$v) {
                _vm.isLoading = $$v
              },
              expression: "isLoading",
            },
          }),
          _c(
            "b-table",
            {
              attrs: {
                data: _vm.histories,
                detailed: "",
                "row-class": (row, index) => (!!row.byPilot ? "is-info" : ""),
                hoverable: "",
              },
              on: { "details-open": _vm.onOpenDetails },
              scopedSlots: _vm._u([
                {
                  key: "detail",
                  fn: function (props) {
                    return _vm._l(props.row.relaunches, function (e, index) {
                      return _c("tr", { key: index }, [
                        _c("td", [
                          _c("strong", [
                            _vm._v(_vm._s(`${index + 1} reminder:`)),
                          ]),
                        ]),
                        _c("td", [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$dayjs(e.sendAt).format("YYYY-MM-DD"))
                          ),
                        ]),
                      ])
                    })
                  },
                },
              ]),
            },
            [
              _c("b-table-column", {
                attrs: { field: "sendAt", label: "Sent on", sortable: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                props.row.sendAt
                                  ? _vm
                                      .$dayjs(props.row.sendAt)
                                      .format("YYYY-MM-DD")
                                  : ""
                              ) +
                              " "
                          ),
                        ],
                      ]
                    },
                  },
                ]),
              }),
              _c("b-table-column", {
                attrs: { field: "sendTo", label: "Sent to" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [[_vm._v(" " + _vm._s(props.row.sendTo) + " ")]]
                    },
                  },
                ]),
              }),
              _c("b-table-column", {
                attrs: { label: "Declaration" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        [
                          _c(
                            "span",
                            {
                              class: [
                                "tag",
                                { "is-danger": !props.row.declarationId },
                                { "is-primary": props.row.declarationId },
                              ],
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    props.row.declarationId ? "Yes" : "No"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                      ]
                    },
                  },
                ]),
              }),
              _c("b-table-column", {
                attrs: {
                  field: "uploadDate",
                  label: "Declared On",
                  sortable: "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                props.row.uploadDate
                                  ? _vm
                                      .$dayjs(props.row.uploadDate)
                                      .format("YYYY-MM-DD")
                                  : ""
                              ) +
                              " "
                          ),
                        ],
                      ]
                    },
                  },
                ]),
              }),
              _c("b-table-column", {
                attrs: { field: "sendType", label: "Type" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                props.row.sendType
                                  ? props.row.sendType
                                  : props.row.byPilot
                                  ? "Operator"
                                  : "N/A"
                              ) +
                              " "
                          ),
                        ],
                      ]
                    },
                  },
                ]),
              }),
              _c("b-table-column", {
                attrs: { label: "File" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        props.row.declarationId && props.row.filePath
                          ? [
                              _c(
                                "b-button",
                                {
                                  attrs: { size: "is-small", type: "is-link" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.downloadFile(
                                        props.row.declarationId
                                      )
                                    },
                                  },
                                },
                                [_vm._v(" Download ")]
                              ),
                            ]
                          : _vm._e(),
                        props.row.declarationId && props.row.hasNothing
                          ? [
                              _c("span", { staticClass: "tag" }, [
                                _vm._v("Nothing declared"),
                              ]),
                            ]
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("b-table-column", {
                attrs: { label: "By" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        [
                          _vm._v(" " + _vm._s(props.row.uploadedBy) + " "),
                          props.row.byPilot
                            ? _c("b-button", {
                                staticClass: "delete-btn",
                                attrs: {
                                  type: "is-danger",
                                  "icon-right": "trash",
                                  size: "is-small",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteDeclaration(
                                      props.row.declarationId
                                    )
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }